import { module } from 'modujs';

const CLASS = {
    IS_SUCCESS: 'is-success',
    IS_LOADING: 'is-loading',
    IS_ERROR: 'is-error'
}

export default class extends module {
    constructor(m) {
        super(m);

        this.events ={
            submit: "submit"
        }
    }

    init() {
        this.confirmMessage = this.getData('confirm-message')
        this.errorMessage = this.getData('error-message')
    }

    /**
     * Set loading state (show loader, fade form, and other UI)
     *
     * @param {none}
     */
    setLoadingState() {
        this.el.classList.add(CLASS.IS_LOADING)
    }

    /**
     * Set confirmation state;
     * Display confirmation message
     *
     * @param {string} | confirmation message
     */
    setConfirmationState(message) {
        this.clearState()

        this.el.classList.add(CLASS.IS_SUCCESS)
        this.$('feedback')[0].innerHTML = message
    }

    /**
     * Set error state
     *
     * @param {message} | form error message
     */
    setErrorState(message) {
        this.clearState()

        this.el.classList.add(CLASS.IS_ERROR)
        this.$('feedback')[0].innerHTML = message
    }

    /**
     * Clear all state
     *
     * @param
     */
    clearState() {
        this.el.classList.remove(CLASS.IS_SUCCESS)
        this.el.classList.remove(CLASS.IS_LOADING)
        this.el.classList.remove(CLASS.IS_ERROR)

        this.$('feedback')[0].innerHTML = ""

    }

    /**
     * Custom submit
     *
     * @param {e} | event
     */
    submit(e) {
        e.preventDefault();
        let isError = false;
        this.clearState()
        this.setLoadingState()
        var formData = new FormData(this.el);
        fetch('/wp-json/notify/restock', {
            method: 'POST',
            body: formData,
        })
        .then(response => {
            if (response.status !== 200 && response.status !== 202) {
                isError = true
            }
            return response.json()
        })
        .then(response => {
            if (isError) {
                console.log('Submit : Error')
                this.setErrorState(this.errorMessage)
            } else {
                console.log('Submit : succes')
                this.setConfirmationState(this.confirmMessage)
            }
        })
    }
}
